module.exports = __webpack_public_path__ + "static/media/siddharth-coorg-trip-18.92dbc764.png";